import { styled } from "../../theme/stitches";

export const ContextMenuShortcut = styled("div", {
  marginLeft: "auto",
  paddingLeft: "$2",
  fontSize: "$caption2",
});
